// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCallout-Content_cls1__2a4+-","cls2":"VeloCallout-Content_cls2__UCLDq VeloCallout-Content_cls1__2a4+-","icon":"VeloCallout-Content_icon__XucWn"};